import React, { Component } from 'react';
import './digitalWatch.scss';

class DigitalWatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: new Date().toLocaleTimeString(),
      themeMode: '',
    };
  }

  componentDidMount() {
    var date = new Date();
    var h = date.getHours(); // 0 - 23
    var m = date.getMinutes(); // 0 - 59
    var s = date.getSeconds(); // 0 - 59
    var session = 'AM';
    this.intervalID = setInterval(() => this.updateClock(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  updateClock() {
    this.setState({
      time: new Date().toLocaleTimeString(),
    });
  }

  render() {
    return (
      <div
        id={this.state.themeMode === 'dark' ? 'dark-mode' : ''}
        className="position-absolute clock"
      >
        <p className="p-0 m-0"> {this.state.time}</p>
      </div>
    );
  }
}

export default DigitalWatch;
